import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FooterLink } from ".";
import { Tooltip } from "../..";
const FooterPoweredByLink = (param)=>{
    let { poweredLink, affiliate } = param;
    return /*#__PURE__*/ _jsxs(FooterLink, {
        href: affiliate ? affiliate.link : poweredLink.href,
        target: poweredLink.target,
        children: [
            /*#__PURE__*/ _jsx("span", {
                dangerouslySetInnerHTML: {
                    __html: poweredLink.innerHTML
                }
            }),
            affiliate && /*#__PURE__*/ _jsxs(Tooltip, {
                title: affiliate.description,
                position: "top-left",
                children: [
                    " ",
                    affiliate.labelBehind
                ]
            })
        ]
    }, "powered-by");
};
export { FooterPoweredByLink };
